import {
  CustomGetOrganizationUsersQuery,
  CustomGetOrganizationUsersQueryVariables,
  useCustomGetOrganizationUsersQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export const cacheKey = "GetOrganizationUsers";

type OrganizationUsersQueryData = CustomGetOrganizationUsersQuery;

export default function useGetOrganizationUsers({
  page = 1,
  first = 10,
  search,
  roles = null,
  status = null,
  archived = null,
}: CustomGetOrganizationUsersQueryVariables) {
  const {
    data: graphqlData,
    loading,
    error,
    fetchMore: more,
  } = useCustomGetOrganizationUsersQuery({
    variables: {
      page,
      first,
      search,
      roles,
      status,
      archived,
    },
  });

  const fetchMore = useCallback(
    async ({ page }: { page: number }) => {
      return more({
        variables: {
          page,
        },
      });
    },
    [more]
  );

  const getData = useCallback(({ data }: { data?: OrganizationUsersQueryData }) => {
    return data?.getOrganizationUsers?.data || null;
  }, []);

  const getPaginatorInfo = useCallback(({ data }: { data?: OrganizationUsersQueryData }) => {
    return data?.getOrganizationUsers?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData, getData]);

  const paginatorInfo = useMemo(() => {
    return getPaginatorInfo({ data: graphqlData });
  }, [graphqlData, getPaginatorInfo]);

  return { data, loading, error, paginatorInfo, fetchMore, getData, getPaginatorInfo } as const;
}
